import React, { useEffect } from 'react';

const SEO = ({
    title = "Victor Cuerdo | Platform Support Engineer",
    description = "Platform Support Engineer with 5+ years in SaaS operations, AWS/Azure cloud infrastructure, and workflow automation. Engineered tooling that cut configuration time by 95%.",
    name = "Victor Cuerdo",
    type = "website",
    url = "https://victorcuerdo.vercel.app",
    image = "https://victorcuerdo.vercel.app/og-image.png"
}) => {

    useEffect(() => {
        document.title = title;

        const updateMeta = (name, content, attribute = 'name') => {
            let element = document.querySelector(`meta[${attribute}="${name}"]`);
            if (!element) {
                element = document.createElement('meta');
                element.setAttribute(attribute, name);
                document.head.appendChild(element);
            }
            element.setAttribute('content', content);
        };

        updateMeta('description', description);
        updateMeta('keywords', "Victor Cuerdo, Platform Support Engineer, Cloud Support Engineer, AWS, Azure, DevRev, Incident Response, SLA Management, Python, Node.js, Workflow Automation, SaaS Operations");
        updateMeta('author', name);

        updateMeta('og:type', type, 'property');
        updateMeta('og:title', title, 'property');
        updateMeta('og:description', description, 'property');
        updateMeta('og:image', image, 'property');
        updateMeta('og:url', url, 'property');
        updateMeta('og:site_name', title, 'property');

        updateMeta('twitter:creator', '@vcuerdo');
        updateMeta('twitter:card', 'summary_large_image');
        updateMeta('twitter:title', title);
        updateMeta('twitter:description', description);
        updateMeta('twitter:image', image);

        const structuredData = {
            "@context": "https://schema.org",
            "@type": "Person",
            "name": name,
            "url": url,
            "image": image,
            "jobTitle": "Platform Support Engineer",
            "worksFor": {
                "@type": "Organization",
                "name": "Pebl (formerly Velocity Global)"
            },
            "sameAs": [
                "https://www.linkedin.com/in/vcuerdo",
                "https://github.com/VictorCuerdo"
            ],
            "knowsAbout": [
                "Platform Support Engineering",
                "Cloud Computing",
                "AWS",
                "Microsoft Azure",
                "DevRev",
                "Incident Response",
                "SLA Management",
                "Python",
                "Node.js",
                "Workflow Automation"
            ],
            "knowsLanguage": ["English", "Spanish", "Russian"],
            "description": description
        };

        let script = document.querySelector('#seo-json-ld');
        if (!script) {
            script = document.createElement('script');
            script.id = 'seo-json-ld';
            script.type = 'application/ld+json';
            document.head.appendChild(script);
        }
        script.text = JSON.stringify(structuredData);

    }, [title, description, name, type, url, image]);

    return null;
}

export default SEO;
